import { styled } from '@linaria/react';
import { Group, Stack } from '@mantine/core';
import type { ComponentData } from '../../../api/pages-client/pages-client.type';
import { baseBlack, skyLight } from '../../../styles/design-tokens';
import { Tooltip } from '../../../ui-library/tooltip/tooltip';
import { Text } from '../../../ui-library/typography/typography';
import type { WidgetDataPoint } from '../hooks/dashboards.hooks.type';

interface TextWidgetProps {
  chartData: WidgetDataPoint[];
  componentData: ComponentData | undefined;
}

export const TextWidget: React.FC<TextWidgetProps> = ({ chartData, componentData }) => {
  const colorMap = componentData?.color_map ?? {};
  return (
    <Stack>
      {chartData.map((data, idx) => (
        <Tooltip key={idx} label={data.objectName} variant="black" multiline style={{ maxWidth: 200 }} zIndex={2000}>
          <TextWidgetItem>
            <Text weight="bold" color={colorMap[data.objectId] ?? colorMap[data?.parentId ?? ''] ?? baseBlack}>
              {data.value}
            </Text>
          </TextWidgetItem>
        </Tooltip>
      ))}
    </Stack>
  );
};

const TextWidgetItem = styled(Group)`
  border-radius: 8px;
  padding: 8px;
  cursor: default;
  &:hover {
    background-color: ${skyLight};
  }
`;
